<template>
  <div>
    <div v-if="loadError" class="empty" role="alert"><p>{{ $t('intake.portal.loadError') }}</p><button class="btn btn-secondary" type="button" @click="bootstrap">{{ lang === 'fa' ? 'تلاش دوباره' : 'Try again' }}</button></div>
    <div v-else-if="loading" class="empty"><p>{{ $t('intake.portal.loading') }}</p></div>
    <div v-else-if="!session" class="empty">
      <h3>{{ $t('intake.portal.sessionMissingTitle') }}</h3>
      <p>{{ $t('intake.portal.sessionMissingBody') }}</p>
      <div class="actions">
        <router-link class="btn btn-primary" :to="r('portalSessions')">{{ $t('intake.portal.sessionsUpcoming') }}</router-link>
      </div>
    </div>
    <template v-else>
      <div class="detail-grid">
        <div class="detail-row">
          <span class="k">{{ $t('intake.portal.sessionDetail_therapist') }}</span>
          <span class="v">{{ therapistName }}</span>
        </div>
        <div class="detail-row">
          <span class="k">{{ $t('intake.portal.sessionDetail_number') }}</span>
          <span class="v">{{ sessionNumber }}</span>
        </div>
        <div class="detail-row">
          <span class="k">{{ $t('intake.portal.sessionDetail_time') }}</span>
          <span class="v">{{ sessionTime }}</span>
        </div>
        <div class="detail-row">
          <span class="k">{{ $t('intake.portal.sessionDetail_status') }}</span>
          <span class="v">{{ statusLabel }}</span>
        </div>
      </div>
      <div class="actions">
        <router-link v-if="canManage" class="btn btn-primary" :to="readyLink">{{ $t('intake.portal.sessionReadyCta') }}</router-link>
        <router-link v-if="canManage" class="btn btn-secondary" :to="rescheduleLink">{{ $t('intake.portal.reschedule') }}</router-link>
        <router-link v-if="canManage" class="btn btn-danger" :to="cancelLink">{{ $t('intake.portal.sessionCancel') }}</router-link>
      </div>
    </template>
  </div>
</template>
<script>
import {
  doctorDisplayName,
  fetchOwnedSession,
  formatSessionListTitle,
  sessionStatusLabel,
  toFaDigits,
  isPastSession,
  isUpcomingSessionState,
} from '@/intake/portalApi'

export default {
  name: 'PortalSessionDetailStep',
  data() {
    return {
      loading: true,
      loadError: false,
      session: null,
      generation: 0,
    }
  },
  computed: {
    canManage() {
      return !!this.session && isUpcomingSessionState(this.session) && !isPastSession(this.session)
    },
    lang() {
      return this.$route.params.lang || 'fa'
    },
    therapistName() {
      return doctorDisplayName(this.session && this.session.doctor, this.lang) || '—'
    },
    sessionNumber() {
      const n = this.session && this.session.session_number
      if (n == null) return '—'
      return this.lang === 'fa' ? toFaDigits(n) : String(n)
    },
    sessionTime() {
      return formatSessionListTitle(this.session, this.lang) || '—'
    },
    statusLabel() {
      return sessionStatusLabel(this.session, this.lang)
    },
    readyLink() {
      return {name: 'intakeReadyOk', params: {lang: this.lang}, query: {id: String(this.session.id)}}
    },
    rescheduleLink() {
      return {
        name: 'intakeSessionReschedule',
        params: {lang: this.lang},
        query: this.session && this.session.id ? {id: String(this.session.id)} : {},
      }
    },
    cancelLink() {
      return {
        name: 'intakeSessionCancel',
        params: {lang: this.lang},
        query: this.session && this.session.id ? {id: String(this.session.id)} : {},
      }
    },
  },
  mounted() {
    this.bootstrap()
  },
  watch: {'$route.query.id'() { return this.bootstrap() }},
  beforeDestroy() { this.generation += 1 },
  methods: {
    r(name) {
      return {name, params: {lang: this.lang, therapistId: 't1'}}
    },
    bootstrap() {
      const generation = ++this.generation
      this.loading = true
      this.loadError = false
      this.session = null
      const rawId = (this.$route.query || {}).id
      const wantedId = rawId != null ? String(rawId).trim() : ''
      return fetchOwnedSession(wantedId)
          .then((session) => {
            if (generation === this.generation) this.session = session
          })
          .catch((error) => {
            if (generation !== this.generation) return
            const status = error && error.response && error.response.status
            this.loadError = ![401,403,404].includes(status)
          })
          .finally(() => {
            if (generation === this.generation) this.loading = false
          })
    },
  },
}
</script>
